import './NoteDisplayArea.scss';
import moment from 'moment';
import React, { useState } from 'react';
import NoteEditArea from './NoteEditArea';
import { useStoreContext } from '../../components/App/StoreProvider';
import { Note } from '../../interfaces/Notes/note';

interface NoteProps {
    note: Note;
    index: number;
    noteOnEditMode: (onEditMode: boolean) => void;
    onDisableMode: boolean;
    onEditNote: (note: string, noteId: number) => void;
    canEditNotes: boolean;
}

const NoteDisplayArea = ({
    note,
    index,
    noteOnEditMode,
    onDisableMode,
    onEditNote,
    canEditNotes,
}: NoteProps): React.ReactElement => {
    const [isDisplayMode, setIsDisplayMode] = useState(true);
    const datePart = moment(note.createdAtUtc.toString()).format('MMM DD, YYYY');
    const timePart = moment(note.createdAtUtc.toString()).format('h:mm A z');

    const onEdit = (): void => {
        noteOnEditMode(true);
        setIsDisplayMode(false);
    };

    const onCancel = (): void => {
        noteOnEditMode(false);
        setIsDisplayMode(true);
    };

    return isDisplayMode ? (
        <div className={`${onDisableMode ? 'NoteDisplayArea-DisableMode' : ''}`}>
            <div
                className={`NoteDisplayArea-Container ${
                    index % 2 === 0 ? 'NoteDisplayArea-OddBackground' : 'NoteDisplayArea-EvenBackground'
                }`}
            >
                <div className="NoteDisplayArea-DetailsContainer">
                    <span className="NoteDisplayArea-UserName">{note.name}</span>
                </div>
                <div className="NoteDisplayArea-DetailsContainer">
                    <span className="NoteDisplayArea-DateTime">
                        {datePart}
                        <span className="NoteDisplayArea-Divider">|</span>
                        {timePart}
                        {note.modifiedAtUtc !== note.createdAtUtc && ` (Edited)`}
                    </span>
                </div>
                <div className="NoteDisplayArea-NoteText">{note.notes}</div>
            </div>
            {canEditNotes && (
                <div className="NoteDisplayArea-FooterContainer">
                    <span className="NoteDisplayArea-Link" onClick={onEdit}>
                        Edit Comment
                    </span>
                </div>
            )}
        </div>
    ) : (
        <NoteEditArea index={index} onCancel={onCancel} onEditNote={onEditNote} note={note} />
    );
};

export default NoteDisplayArea;

